module.exports = {
    name:      "swampland2",
    buildDate: "Wed May 15 2019 15:22:56 GMT+0400 (Samara Standard Time)",
    version:   "1.0.0",
    build:     "3.2348 debug"
};



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 10
// module chunks = 0